<aside
  class="sidebar position-fixed top-0 start-0 vh-100 border-end"
  [class.sidebar-expanded]="(layoutService.isExpanded$ | async) || (layoutService.isHovered$ | async)"
  [class.sidebar-collapsed]="!(layoutService.isExpanded$ | async) && !(layoutService.isHovered$ | async)"
  [class.sidebar-mobile-open]="layoutService.isMobileOpen$ | async"
>

  <!-- 🔒 FIXED LOGO (NO SCROLL) -->
  <div class="sidebar-logo d-flex justify-content-between align-items-center px-3">
    <a routerLink="/" class="fw-bold">
      <img
        src="assets/logo/ksna-logo-dark.png"
        alt="Eventz Logo"
        loading="lazy"
        class="img-fluid"
        [style.height.px]="
        (layoutService.isExpanded$ | async) || (layoutService.isHovered$ | async)
          ? 40
          : 40
      "
      />
    </a>
    <!-- Mobile Close -->
    <button
      class="btn btn-sm d-xl-none"
      (click)="closeSidebar()"
      aria-label="Close sidebar"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>

  <!-- Menu -->
  <div class="sidebar-menu no-scrollbar py-3 px-2">
    <nav class="mb-6">
      <ul class="flex flex-col gap-1">

        <!-- =====================
             MAIN NAV
        ====================== -->
        @for (nav of navItems; track $index; let i = $index) {

          <li>

            @if (nav.subItems) {

              <button
                (click)="toggleSubmenu('main', i)"
                class="menu-item"
                [class.menu-item-active]="openSubmenu === 'main-' + i">

                <span class="menu-item-icon-size">{{ nav.icon }}</span>

                @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                  <span class="menu-item-text">{{ nav.name }}</span>
                }

              </button>

              <div
                [id]="'main-' + i"
                [ngStyle]="{
          height: openSubmenu === 'main-' + i
            ? (subMenuHeights['main-' + i] || 0) + 'px'
            : '0px'
        }">

                <ul class="mt-2 space-y-1 ml-9">
                  @for (subItem of nav.subItems; track $index) {
                    <li>
                      <a
                        [routerLink]="subItem.path"
                        class="menu-dropdown-item"
                        (click)="onSubmenuClick()">
                        {{ subItem.name }}
                      </a>
                    </li>
                  }
                </ul>

              </div>

            } @else {

              <a
                [routerLink]="nav.path"
                class="menu-item"
                [ngClass]="{
          'menu-item-active': isActive(nav.path!),
          'menu-item-inactive': !isActive(nav.path!)
        }">

                <span class="menu-item-icon-size">{{ nav.icon }}</span>

                @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                  <span class="menu-item-text">{{ nav.name }}</span>
                }

              </a>

            }

          </li>

        }

      </ul>
    </nav>
  </div>
</aside>
